import React from "react";
import { Container, Typography, Box, Divider, Chip, Paper, Stack, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMedal, faMoneyBillWave, faTriangleExclamation, faHandshake, faGavel, faFlagCheckered } from "@fortawesome/free-solid-svg-icons";
import SectionTitle from "../../components/layouts/others/title-section.layout";

const POST20230916: React.FC = () => {
    return (
        <Container sx={{ mb: 5 }}>
            <SectionTitle title={"ESPACE INFORMATIONS DES HABITANTS"} />
            <Box mt={3} mb={2}>
                <Typography
                    variant="h6"
                    fontWeight={700}
                    align="center"
                    gutterBottom
                    color="primary"
                >
                    Projet d’équipements sportifs
                </Typography>
            </Box>

            <Paper elevation={2} sx={{ p: { xs: 2, sm: 4 }, background: "#fafcfe" }}>
                <Stack spacing={2}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <FontAwesomeIcon icon={faMedal} size="lg" color="#0d47a1" />
                        <Typography variant="subtitle1" fontWeight={600}>
                            Une attente depuis 2018
                        </Typography>
                    </Box>
                    <Typography>
                        Les associations sportives attendent depuis 2018 que la municipalité investisse dans des infrastructures leur permettant de répondre à la demande croissante des habitants. Les installations actuelles couvrent moins d&apos;un tiers de leurs besoins.
                    </Typography>

                    <Divider>
                        <Chip label="Rétrospective" color="primary" variant="outlined" />
                    </Divider>

                    <List dense>
                        <ListItem>
                            <ListItemIcon>
                                <FontAwesomeIcon icon={faGavel} color="#02a676" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<>
                                    <strong>Mai 2022</strong> : Le cabinet <b>IngéSports</b> remet un rapport à la municipalité, identifiant de fortes carences (salles multisports, équipements d’athlétisme, structure d’escalade) et propose <b>3 scénarios</b>.
                                </>}
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <FontAwesomeIcon icon={faHandshake} color="#f57c00" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<>
                                    <strong>26/06/2023</strong> : Le conseil municipal valide le programme d’appel à maîtrise d’œuvre et les primes attribuées.<br />
                                    <strong>21/09/2023</strong> : Obligation de revoir les montants, ils étaient erronés.
                                </>}
                            />
                        </ListItem>
                    </List>

                    <Box>
                        <Typography fontWeight={700} color="secondary" mb={1}>
                            Focus sur les points essentiels
                        </Typography>
                        <List dense>
                            <ListItem>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faMoneyBillWave} color="#388e3c" />
                                </ListItemIcon>
                                <ListItemText
                                    primary={<>Travaux estimés à <b>plus de 10M€</b>, sans plan de financement présenté.</>}
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faTriangleExclamation} color="#e53935" />
                                </ListItemIcon>
                                <ListItemText
                                    primary={<>Aucune programmation fonctionnelle ou technique communiquée.</>}
                                />
                            </ListItem>
                        </List>
                    </Box>

                    <Divider>
                        <Chip label="Notre analyse" color="secondary" variant="outlined" />
                    </Divider>
                    <Typography>
                        En septembre 2022, nous alertions déjà sur le manque d’équipements et appelions à une large concertation incluant:
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemIcon>
                                <FontAwesomeIcon icon={faHandshake} color="#6942ab" />
                            </ListItemIcon>
                            <ListItemText primary="Une réflexion sur les impacts financiers et environnementaux" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <FontAwesomeIcon icon={faMedal} color="#0097a7" />
                            </ListItemIcon>
                            <ListItemText primary="Une étude comparative entre communes" />
                        </ListItem>
                    </List>
                    <Typography>
                        Aucune démarche de ce type n'a été entreprise par la majorité.
                    </Typography>

                    <Divider light />

                    <Typography>
                        Nous ne mettons pas en doute la volonté des élus de faire progresser ce dossier. Cependant, le lancement tardif, l&apos;absence de planification et le flou sur le financement interrogent quant à la réelle intention d&apos;investir dans les équipements sportifs de la commune.
                    </Typography>
                    <Typography>
                        <FontAwesomeIcon icon={faFlagCheckered} color="#1565c0" style={{ marginRight: 8 }} />
                        Les travaux ne devraient pas commencer avant les prochaines élections municipales.
                    </Typography>
                    <Typography>
                        La décision de poursuivre ou non ce projet reviendra à la nouvelle équipe municipale, après déjà plusieurs dizaines de milliers d’euros dépensés en études.
                    </Typography>
                </Stack>
            </Paper>
        </Container>
    );
};

export default POST20230916;